import { Component, OnInit } from '@angular/core';
import { CartService } from 'src/app/services/cart.service';
import { WishlistService } from 'src/app/services/wishlist.service';

@Component({
  selector: 'cart-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less']
})
export class CartIndexComponent implements OnInit {
  tabSelectedIndex: number = 0;
  productList: any = [];
  wishList:any=[];
  constructor(private cartService:CartService,private wishlistService:WishlistService) { }

  ngOnInit(): void {
    this.cartService.cartData$.subscribe((cartData: any) => {
      //Traverse the productList and add the errorType attribute to each product
      this.productList = cartData.list;
    })
    this.wishlistService.wishListData$.subscribe((wishData: any) => {
      //Traverse the productList and add the errorType attribute to each product
      this.wishList = wishData;
    })

  }
  onTabChange(index: number) {
    this.tabSelectedIndex = index;
  }

}
